import { useEffect, useState } from 'react';
import Header from '../../components/Header/Header';
import { getGoals, getSchoolWithColumns, setMatrixLabelData } from '../../utils/functions';
import { Link, useHistory } from 'react-router-dom';
import Footer from '../../components/Footer/Footer';

function ISSLCSchoolColumnEdit(props) {
    const history = useHistory();
    const [school, setSchool] = useState();
    const [rows, setRows] = useState([]);
    const [columns, setColumns] = useState([]);
    const [hideForPrincipalObject, setHideForPrincipalObject] = useState({});
    useEffect(() => {
        const getAndSetSchool = async () => {
            const theSchool = await getSchoolWithColumns('ISSLC', props.match.params.schoolId);
            setSchool(theSchool[0]);
        };

        const getAndSetRows = async () => {
            const theRows = await getGoals('row', 'ISSLC', null, props.match.params.schoolId);
            setRows(theRows);
        };

        const getAndSetColumns = async () => {
            const theColumns = await getGoals('column', 'ISSLC', null, props.match.params.schoolId);
            setColumns(theColumns);
        };

        getAndSetSchool();
        getAndSetRows();
        getAndSetColumns();
    }, []);

    const getAwspText = (rowId) => {
        let awsp = 'Select AWSP Criteria';
        school.parameters.forEach((param) => {
            if (param.row_id === rowId && Array.isArray(param.awsp) && param.awsp?.length) {
                awsp = param.awsp.map((awsp, index) => {
                    return (
                        <>
                            {awsp}
                            {index !== param.awsp.length - 1 ? ',' : ''}
                            <br />
                        </>
                    );
                });
            }
        });
        return awsp;
    };

    const onClickHideForPrincipal = async (e, labelId) => {
        const value = e.target.checked;
        hideForPrincipalObject[labelId] = !value;
        setHideForPrincipalObject({ ...hideForPrincipalObject });
    };

    const onClickSave = async (e) => {
        e.preventDefault();

        for (const [labelId, hideForPrincipal] of Object.entries(hideForPrincipalObject)) {
            await setMatrixLabelData(props.match.params.schoolId, labelId, 'ISSLC', {
                hide_for_principal: hideForPrincipal,
            });
        }
        history.push(`/isslc/${props.match.params.schoolId}`);
    };

    const getIsCheckedHideForPrincipal = (label) => {
        if (hideForPrincipalObject[label._id] !== undefined) {
            return hideForPrincipalObject[label._id] !== true;
        }
        return label.hideForPrincipal !== true;
    };

    return (
        <>
            <Header title={school?.name} />

            <main className={''}>
                <div className={'edit-form'} style={{ paddingLeft: '100px' }}>
                    <button className={'mt-5 mb-5'} type={'submit'} style={{ float: 'left' }} onClick={onClickSave}>
                        Save
                    </button>
                </div>
                <div className={'grid-container single-school-table'}>
                    <table className={'grid-table center mt-5 ml-1'} cellSpacing={0}>
                        <tbody>
                            <tr>
                                <td className={'select-column-label select-column-label-left'}>
                                    Select which columns to show ↆ
                                </td>
                                <td className={'table-header table-header-awsp'} style={{ width: '350px' }}>
                                    AWSP
                                </td>
                                <td className={'table-header table-header-school-name'} style={{ width: '150px' }}>
                                    <span className={'select-column-label select-column-label-top'}>
                                        Select which columns to show →
                                    </span>
                                    Leadership Standards
                                </td>
                                {columns.map((col, index) => (
                                    <th className={'column-header'} key={index} data-id={col._id} scope={'col'}>
                                        <span className={'column-checkbox'}>
                                            <input
                                                type={'checkbox'}
                                                checked={getIsCheckedHideForPrincipal(col)}
                                                onChange={(e) => {
                                                    onClickHideForPrincipal(e, col._id);
                                                }}
                                            />
                                        </span>
                                        {col.name}
                                    </th>
                                ))}
                            </tr>
                            {school &&
                                rows &&
                                columns &&
                                rows.map((row, index) => {
                                    return (
                                        <tr key={index}>
                                            <th>
                                                <span className={'row-checkbox'}>
                                                    <input
                                                        type={'checkbox'}
                                                        checked={getIsCheckedHideForPrincipal(row)}
                                                        onChange={(e) => {
                                                            onClickHideForPrincipal(e, row._id);
                                                        }}
                                                    />
                                                </span>
                                            </th>
                                            <th
                                                className={`row-header-${index % 2}`}
                                                style={{ borderRight: '1px solid black', textAlign: 'left' }}
                                            >
                                                <Link to={`/isslc/awsp-edit/${props.match.params.schoolId}/${row._id}`}>
                                                    {school && getAwspText(row._id)}
                                                </Link>
                                            </th>
                                            <th className={`row-header-${index % 2}`} scope={'row'}>
                                                {row.name}
                                            </th>
                                        </tr>
                                    );
                                })}
                        </tbody>
                    </table>
                </div>
            </main>
            <Footer />
        </>
    );
}

export default ISSLCSchoolColumnEdit;
